export enum EConstructorInitiator {
  /** when user create preset before new chat */
  USER = 'user',
  /** when user create preset for new chatbot */
  AUTHOR = 'author',
  /** when user create or update current model-prompt in existing chat */
  CHAT = 'chat',
  /** when user create or update preset in existing chat */
  PRESET = 'preset',
}
